export const HomePageExplore = [
    {
        tag: 'MATH',
        courses : [
           {
    heading : "Algebra Fundamentals",
    description : "This course covers the core concepts of algebra including variables, linear equations, expressions, and problem-solving techniques.",
    level : 'Beginner',
    lessionNumber : 8
},
{
    heading : "Geometry Basics",
    description : "This course introduces important geometry topics such as lines, angles, triangles, circles, and their properties with practical examples.",
    level : 'Beginner',
    lessionNumber : 7
},
{
    heading : "Trigonometry Essentials",
    description : "This course explains trigonometric ratios, identities, and their applications in solving mathematical and real-world problems.",
    level : 'Intermediate',
    lessionNumber : 9
}
        ]
    },
    {
        tag: 'SCIENCE',
        courses : [
           {
    heading : "Physics",
    description : "This course covers the fundamental concepts of physics including motion, force, energy, electricity, and real-world applications of physical laws.",
    level : 'Beginner',
    lessionNumber : 6
},
{
    heading : "Chemistry",
    description : "This course introduces the basic principles of chemistry including atoms, molecules, chemical reactions, and the laws of chemical combination.",
    level : 'Beginner',
    lessionNumber : 6
},
{
    heading : "Biology",
    description : "This course explores the fundamentals of biology including cell structure, plant and animal systems, and the basic processes of life.",
    level : 'Beginner',
    lessionNumber : 6
}
        ]
    },
    {
        tag: 'ARTIFICAL INTELLIGENT',
        courses : [
           {
    heading : "Machine Learning",
    description : "This course introduces the fundamentals of machine learning including data, algorithms, and how computers learn patterns to make predictions.",
    level : 'Beginner',
    lessionNumber : 6
},
{
    heading : "Python for AI",
    description : "This course teaches Python programming concepts used in artificial intelligence including data handling, basic libraries, and simple AI models.",
    level : 'Beginner',
    lessionNumber : 6
},
{
    heading : "AI Fundamentals",
    description : "This course explains the core ideas of artificial intelligence including neural networks, automation, and real-world AI applications.",
    level : 'Beginner',
    lessionNumber : 6
}
        ]
    },
    {
        tag: 'CODING',
        courses : [
            {
    heading : "Python Programming",
    description : "This course introduces the fundamentals of Python programming including variables, loops, functions, and basic problem solving.",
    level : 'Beginner',
    lessionNumber : 6
},
{
    heading : "Web Development",
    description : "This course teaches the fundamentals of web development including HTML, CSS, and JavaScript to build modern and responsive websites.",
    level : 'Beginner',
    lessionNumber : 6
},
{
    heading : "Problem Solving with Code",
    description : "This course focuses on developing logical thinking and solving real-world problems using coding techniques and algorithms.",
    level : 'Beginner',
    lessionNumber : 6
}
        ]
    },
    {
        tag: 'TEST & PRACTICE',
        courses : [
           {
    heading : "Live Test (Cooch Behar Ranking)",
    description : "Students can take live tests in Math, Physics, Chemistry, Biology, AI, and Python. After completing the test, they can check their rank among students across Cooch Behar. This test is completely free.",
    level : "All Levels",
    link : "https://allcobexam.netlify.app/"
},
{
    heading : "Practice Test",
    description : "This section is designed for students to practice different topics and improve their understanding. Students can attempt multiple practice questions and prepare themselves for upcoming exams.",
    level : "All Levels",
    link : "https://allcobexam.netlify.app/"
},
{
    heading : "Topic Wise Weekly Test (offline and online Both)",
    description : "Students can take weekly topic-wise tests for Math, Physics, Chemistry, Biology, AI, and Python to strengthen their concepts and track their progress regularly.",
    level : "All Levels",
    lessionNumber : 8
}
        ]
    },
]